import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { SessionErrorContextProvider } from "../../portal";
import { ApplicationConfigContextProvider } from "@limitless/common/hooks/app-config/AppConfigContext";
import { NotificationContextProvider } from "@limitless/common/hooks/notification/NotificationContext";
import { DevLoggingProvider } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { PlatformResourceContextProvider } from "@limitless/common/hooks/platform-resource/PlatformResourceContext";
import { ExpertProfileContextProvider } from "../hooks/expert-profile/ExpertProfileContext";
import { AuthenticationContextProvider } from "../hooks/authentication/AuthenticationContext";
import { SignInContextProvider } from "../hooks/sign-in/SignInContext";
import { LoginWrapperContextProvider } from "../hooks/sign-in/LoginWrapperContext";

/**
 *   convenience wrapper around some common hooks needed at root level for all Portals
 */
const PortalContextProvider = ({
  children,
  configItems,
  disableWebSockets = false,
  resourceList,
  applicationName,
  defaultContentMap = {},
  previousLocale,
  appAccessPolicy
}) => {
  return /*#__PURE__*/React.createElement(DevLoggingProvider, null, /*#__PURE__*/React.createElement(ApplicationConfigContextProvider, {
    configItems: configItems
  }, /*#__PURE__*/React.createElement(PlatformResourceContextProvider, {
    resourceList: resourceList,
    applicationName: applicationName,
    defaultContentMap: defaultContentMap,
    previousLocale: previousLocale
  }, /*#__PURE__*/React.createElement(NotificationContextProvider, null, /*#__PURE__*/React.createElement(SessionErrorContextProvider, null, /*#__PURE__*/React.createElement(ExpertProfileContextProvider, null, /*#__PURE__*/React.createElement(AuthenticationContextProvider, {
    disableWebSockets: disableWebSockets,
    appAccessPolicy: appAccessPolicy
  }, /*#__PURE__*/React.createElement(LoginWrapperContextProvider, null, /*#__PURE__*/React.createElement(SignInContextProvider, null, children)))))))));
};
export default PortalContextProvider;
PortalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  configItems: PropTypes.array.isRequired,
  disableWebSockets: PropTypes.bool,
  resourceList: PropTypes.array.isRequired,
  applicationName: PropTypes.string.isRequired,
  defaultContentMap: PropTypes.object,
  previousLocale: PropTypes.string,
  appAccessPolicy: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};